/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import SectionHeader from './SectionHeader';
import SortableList from '/client/src/components/sortableList/container';
import arrayMove from 'array-move';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { getEmbedUrlYoutube, ytRegExp } from '/client/src/utils/youTubeEmbedUrl';
import { getEmbedUrlVimeo, viRegExp } from '/client/src/utils/vimeoEmbedUrl';
import { validateVideoUrl } from '../../utils';
import _ from 'lodash';

type PropsType = {
  onHandleChangeVideo: () => void,
  editablePart?: any

};

const Video = (props: PropsType): React.Element => {
  const { onHandleChangeVideo, editablePart } = props;

  const initUrls = () => {
    const urls =  _.get(editablePart, 'urls', []);

    return urls.map((el, i) => ({
     ...el,
     id: 0 - i,
     temp_id: -1001 - i,
     can_delete: true
   }));
   };

  const [urls, setUrls] = React.useState(initUrls());
  const urlRef = React.useRef();
  const context = React.useContext(DefaultContainerContext);

  const onSortEnd = ({ oldIndex, newIndex }: any) => {
    const newItems = arrayMove(urls, oldIndex, newIndex);

    setUrls(newItems);

    onHandleChangeVideo({
      videos: _.map(newItems, (_url: {}, urli: number): {} => {
        return {
          url: _url.url,
          placement_index: urli + 1
        };
      })
    });
  };

  const handleAddUrl = () => {
    const url = urlRef.current.value;

    if (!validateVideoUrl(url)) {
      context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: 'Video URL is invalid!'
      });
      return false;
    }

    const newItems = [
      ...urls,
      {
        id: 0 - _.size(urls),
        name: '',
        temp_id: -1001 - _.size(urls) - 1,
        url,
        can_delete: true
      }
    ];

    setUrls(newItems);
    urlRef.current.value = '';

    onHandleChangeVideo({
      videos: _.map(newItems, (_url: {}, urli: number): {} => {
        return {
          url: _url.url,
          placement_index: urli + 1
        };
      })
    });
  };

  const handleRemoveUrl = (tempId: string | number, id: string | number) => {
    const newItems = _.map(urls, (t: {}): {} => {
      if (t.tempId) {
        if (t.tempId !== tempId) {
          return t;
        }
      } else if (t.id !== id) {
        return t;
      }
    });

    const newFiltered = _.compact(newItems);

    setUrls(newFiltered);
    onHandleChangeVideo({
      videos: _.map(newFiltered, (_url: {}, urli: number): {} => {
        return {
          url: _url.url,
          placement_index: urli + 1
        };
      })
    });
  };

  return (
    <>
      <SectionHeader
        {...props}
        onHandleChange={onHandleChangeVideo}
        title={_.get(editablePart, 'link_label') || 'Video'}
      />

      <div className="row">
        <div className="col-xs-12">
          <div className="form-group SimpleInput">
            <label className="col-xs-12 control-label">Youtube or Vimeo URL</label>
            <div className="col-xs-12">
              <div className="input-group">
                <input
                  ref={urlRef}
                  type="text"
                  className="form-control"
                  id='input-add-video-url'
                />
                <span className="input-group-btn">
                  <button
                    id='button-add-video-player'
                    className="btn btn-default"
                    type="button"
                    onClick={handleAddUrl}
                  >add player</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {!!_.size(urls) &&
        <div className="row">
          <div className="col-xs-12">
            <br />
            <SortableList
              items={urls}
              // eslint-disable-next-line
              onSortEnd={onSortEnd}
              useDragHandle
              useWindowAsScrollContainer
              disableAutoscroll
              // eslint-disable-next-line
              handleRemoveTicket={handleRemoveUrl}
              item={Video2}
              // eslint-disable-next-line
              handleControlTicketData={setUrls}
              withoutTitle
            />
          </div>
        </div>
      }
    </>
  );
};

type Video2PropsType = {
  id?: string | number,
  value: {
    temp_id?: string | number,
    url: string
  }
};

const Video2 = (props: Video2PropsType): React.Element<'div'> => {
  return (
    <div
      className="splash-iframe embed-responsive"
      key={`p.audio-${props.value.temp_id || props.id}`}
      style={{
        height: 300
      }}
    >
      <iframe
        frameBorder="0"
        allowTransparency
        allowFullScreen
        src={props.value.url.match(viRegExp) ? getEmbedUrlVimeo(props.value.url) : getEmbedUrlYoutube(props.value.url)}
        style={{
          height: 300
        }}
      />
    </div>
  );
};

export default Video;
